import React, {Component} from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../constants/Languages.js';
import { outerWidth } from '../../scripts/carousel/Dimensions.js';
import CSSTranslate from '../../scripts/carousel/Translate.js';

class CarouselMain extends Component {
    static defaultProps = {
        transitionTime: 350,
        axis: 'horizontal'
    };

    constructor(props) {
        super(props);

        this.state = {
            initialized: false,
            firstItem: 0
        }
    };

    componentDidMount() {
        if (!this.props.data || this.props.data.length === 0) {
            return;
        }
        this.setupCarousel();
    };

    componentDidUpdate(prevProps, prevState) {
        if (this.props.data && this.props.data.length > 0 && !prevState.initialized) {
            this.setupCarousel();
        }
    };

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateSizes);
        window.removeEventListener("DOMContentLoaded", this.updateSizes);
    };

    setupCarousel = () => {
       window.addEventListener("resize", this.updateSizes);
       window.addEventListener("DOMContentLoaded", this.updateSizes);

       this.setState({
          initialized: true,
       });

       this.updateSizes();
    };

    updateSizes = () => {
        if (!this.state.initialized) {
           return;
        }

        const total = this.props.data.length;
        this.wrapperSize = this.itemsWrapper.clientWidth;
        this.itemSize = this.props.thumbWidth ? this.props.thumbWidth : outerWidth(this.refs.item0);
        this.visibleItems = Math.floor(this.wrapperSize / this.itemSize);
        this.lastPosition = total - this.visibleItems;

        this.setState({
            lastPosition: this.lastPosition,
            itemSize: this.itemSize,
            firstItem: 0
        });
    };

    slideRight = () => {
        this.moveTo(this.state.firstItem - 1);
    };

    slideLeft = () => {
        this.moveTo(this.state.firstItem + 1);
    };

    moveTo = (position) => {
        position = position < 0 ? 0 : position;
        position = position >= this.state.lastPosition ? this.state.lastPosition : position;

        this.setState({
            firstItem: position
        });
    };

    render() {
        if (!this.props.data || this.props.data.length === 0) {
            return null;
        }

        const { data, getListItem, clang } = this.props;
        const { firstItem, lastPosition, itemSize } = this.state;
        let itemListStyles = {};

        const hasPrev = firstItem > 0;
        const hasNext = firstItem < lastPosition;

        const currentPosition =
            firstItem === lastPosition && firstItem !== 0 ?
                '-' + firstItem * itemSize - (Math.floor(this.itemsWrapper.clientWidth / itemSize) * itemSize - this.itemsWrapper.clientWidth) + 'px'
                : '-' + firstItem * itemSize + 'px';

        const transformProp = CSSTranslate(currentPosition, 'horizontal');
        const transitionTime = this.props.transitionTime + 'ms';

        itemListStyles = {
                    'WebkitTransform': transformProp,
                       'MozTransform': transformProp,
                        'MsTransform': transformProp,
                         'OTransform': transformProp,
                          'transform': transformProp,
                        'msTransform': transformProp,
           'WebkitTransitionDuration': transitionTime,
              'MozTransitionDuration': transitionTime,
               'MsTransitionDuration': transitionTime,
                'OTransitionDuration': transitionTime,
                 'transitionDuration': transitionTime,
               'msTransitionDuration': transitionTime
        };

        return (
            <div className={`carousel-main__container ${!hasPrev ? 'no-prev' : ''} ${!hasNext ? 'no-next' : ''}`} >
                {(hasPrev || hasNext) &&
                    <button type="button" className={`carousel-main__prev ${!hasPrev ? 'disabled' : ''}`} onClick={this.slideRight} title={lang[clang].title.carousel_prev}>
                        <div className="carousel-main__arrow-left"></div>
                    </button>}
                <div ref={node => this.itemsWrapper = node} className="carousel-main__wrapper">
                    <ul className="carousel-main" style={itemListStyles}>
                        {data.map((dataItem, index) => getListItem(dataItem, index))}
                    </ul>
                </div>
                {(hasPrev || hasNext) &&
                    <button type="button" className={`carousel-main__next ${!hasNext ? 'disabled' : ''}`} onClick={this.slideLeft} title={lang[clang].title.carousel_next}>
                        <div className="carousel-main__arrow-right"></div>
                    </button>}
            </div>
        );
    }
};

CarouselMain.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(CarouselMain);



// WEBPACK FOOTER //
// ./src/components/carousel/CarouselMain.js